import axiosInstance, { getApiErrorMessage } from "../auth/apiConfig";

const WEB_BASE = "/api/v1/web/medical-records";

const STATUS_TO_API = {
  All: 0,
  "In Queue": 1,
  Called: 2,
  "On going": 3,
};

export const mapQueueRow = (row) => ({
  visitId: row.visitId,
  regId: row.regId,
  patientId: row.regId,
  patientName: row.patientName || "-",
  age: row.ageYear != null ? String(row.ageYear) : "",
  gender: row.genderName || "",
  contact: row.contact || "",
  uhid: row.uhid || "",
  departmentId: row.departmentId,
  department: row.departmentName || "",
  doctorId: row.doctorId,
  doctor: row.doctorName || "",
  doctorName: row.doctorName || "",
  tokenNo: row.tokenNo != null ? `T-${row.tokenNo}` : "",
  visitNo: row.opdNo || "",
  opdNo: row.opdNo || "",
  visitDate: row.visitDate,
  visitTime: row.visitTime,
  queueStatus: row.queueStatus || "In Queue",
  casePaperId: row.casePaperId,
});

export const listMedicalRecordQueue = async (params = {}) => {
  try {
    const response = await axiosInstance.get(WEB_BASE, {
      params: {
        fromDate: params.fromDate,
        toDate: params.toDate,
        departmentId: params.departmentId || undefined,
        doctorId: params.doctorId || undefined,
        q: params.q?.trim() || undefined,
        status: STATUS_TO_API[params.status] ?? params.status ?? 0,
      },
    });
    return (response.data?.data ?? []).map(mapQueueRow);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, "Failed to load medical record queue"));
  }
};

export const callMedicalRecordVisit = async (visitId) => {
  try {
    const response = await axiosInstance.post(`${WEB_BASE}/visits/${visitId}/call`);
    return mapQueueRow(response.data?.data ?? {});
  } catch (error) {
    throw new Error(getApiErrorMessage(error, "Failed to call patient"));
  }
};

export const searchMedicalDepartments = async (query, top = 50) => {
  try {
    const response = await axiosInstance.get(`${WEB_BASE}/departments`, {
      params: { q: query?.trim() || undefined, top },
    });
    return (response.data?.data ?? []).map((item) => ({
      id: item.id,
      label: item.name,
      value: item.id,
    }));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, "Failed to load departments"));
  }
};

export const searchMedicalDoctors = async (query, top = 50) => {
  try {
    const response = await axiosInstance.get(`${WEB_BASE}/doctors`, {
      params: { q: query?.trim() || undefined, top },
    });
    return (response.data?.data ?? []).map((item) => ({
      id: item.id,
      label: item.name,
      value: item.id,
    }));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, "Failed to load doctors"));
  }
};
